// Google One Tap's auto sign-in, turned off at sign-out (owner-approved V2 change, 2026-10-27).
//
// The login page starts One Tap with auto_select, which signs a returning Google account in by itself. Without this,
// a sign-out lands on /login and the same account is signed straight back in ("Signing you in…"). Google's rule for a
// sign-out is disableAutoSelect: it records the choice in Google's own cookie, and the next One Tap asks instead.

type GoogleId = { disableAutoSelect?: () => void };

const googleId = (): GoogleId | undefined =>
  (window as unknown as { google?: { accounts?: { id?: GoogleId } } }).google?.accounts?.id;

/** Google Identity Services, loaded for this one call where the page does not have it (the login page loads it itself). */
export const GSI_SRC = 'https://accounts.google.com/gsi/client';

/** Turns One Tap's auto sign-in off. Waits at most `waitMs` for Google's script; a page that cannot load it goes on. */
export async function stopGoogleAutoSelect(waitMs = 1500): Promise<void> {
  try {
    if (!googleId()?.disableAutoSelect) {
      await new Promise<void>((resolve) => {
        const el = document.createElement('script');
        const timer = window.setTimeout(resolve, waitMs);
        el.src = GSI_SRC;
        el.async = true;
        el.onload = el.onerror = () => {
          window.clearTimeout(timer);
          resolve();
        };
        document.head.appendChild(el);
      });
    }
    googleId()?.disableAutoSelect?.();
  } catch {
    /* no Google script: nothing to turn off */
  }
}
